"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import UiMenuBar from "@/components/menu/UiMenuBar.vue";
import { AccountSessionMixins } from "@/service/account-session";
let MainViewMode = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.no_hide_vd = true;
  }
  mounted() {
    if (this.$session.type === "user" && (this.$session.role_name !== "\u7BA1\u7406\u5458" && this.$session.role_name !== "administrators" && this.$session.role_name !== "Administrador") && this.$session.permissions.is("VD_LIST_MODE_INVISIBLE")) {
      localStorage.setItem("page_mode", "shop");
      this.no_hide_vd = false;
    }
  }
  removePageMode() {
    localStorage.removeItem("page_mode");
  }
  pageMode(path) {
    if (path === "vd") {
      localStorage.removeItem("page_mode");
    }
    if (path === "shop") {
      localStorage.setItem("page_mode", "shop");
    }
  }
  redirect(path) {
    if (path === "vd") {
      localStorage.removeItem("page_mode");
      this.$router.push("/");
    }
    if (path === "shop") {
      localStorage.setItem("page_mode", "shop");
      this.$router.push("/virtual-shop");
    }
  }
};
__decorateClass([
  PropSync("collapse")
], MainViewMode.prototype, "_collapse", 2);
MainViewMode = __decorateClass([
  Component({
    components: {
      UiMenuBar
    }
  })
], MainViewMode);
export {
  MainViewMode as default
};
